import React, { FC } from 'react';

import { ReferralUser } from 'api-client';
import { Money } from 'components/common';
import { formatDate } from 'formatters';

import styles from './ReferralUserMobileCard.module.scss';

interface Props {
  user: ReferralUser;
}

const ReferralUserMobileCard: FC<Props> = ({ user }) => {
  const transactions = user.transactions ?? [];

  return (
    <article className={styles.card}>
      <div className={styles.header}>
        <div className={styles.userInfo}>
          <div className={styles.name}>{user.name || '—'}</div>
          <div className={styles.phone}>{user.phone || '—'}</div>
        </div>
        <div className={styles.accrued}>
          <span className={styles.metricLabel}>Начислено</span>
          <span className={styles.accruedValue}>
            {user.totalUserAccrued ? <Money money={user.totalUserAccrued} /> : '—'}
          </span>
        </div>
      </div>

      <div className={styles.metrics}>
        <div className={styles.metric}>
          <span className={styles.metricLabel}>Дата регистрации</span>
          <span className={styles.metricValue}>
            {user.registerDate ? formatDate(user.registerDate) : '—'}
          </span>
        </div>
        <div className={styles.metric}>
          <span className={styles.metricLabel}>Ставка дохода</span>
          <span className={styles.metricValue}>{user.totalUserAccrued ? '1% бессрочно' : '—'}</span>
        </div>
      </div>

      {transactions.length > 0 && (
        <div className={styles.transactions}>
          <div className={styles.metricLabel}>Начисления</div>
          {transactions.map((transaction) => (
            <div className={styles.transaction} key={transaction.uuid}>
              <div className={styles.transactionInfo}>
                <span className={styles.transactionDate}>{formatDate(transaction.date)}</span>
                <span className={styles.transactionInvested}>
                  Инвестиция{' '}
                  {transaction.investedMoney && transaction.investedMoney.amount > 0 ? (
                    <Money money={transaction.investedMoney} />
                  ) : (
                    '—'
                  )}
                </span>
              </div>
              <span className={styles.transactionValue}>
                <Money money={transaction.money} />
              </span>
            </div>
          ))}
        </div>
      )}
    </article>
  );
};

export default ReferralUserMobileCard;
